import type { CSSProperties } from 'react'
/**
 * Photos are never cropped. Each one sits whole inside its frame, over a blurred
 * copy of itself, so any shape fills the space and nothing is cut off.
 */
export const photoFrame = (src?: string | null): CSSProperties | undefined =>
  src ? ({ '--photo': `url("${src}")` } as CSSProperties) : undefined
